import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";
import ModalLoading from "../sections/ModalLoading";
import Collapsible from "react-collapsible";
import Icon from "../sections/MUI/Icon";

class Orders extends Component {

    state = {
        orders: null,
        servicesOrders: []
    };

    componentDidMount() {
        this.props.setTitle("سفارشات");
        this.getOrders();
        this.getServicesOrders();
    }

    getServicesOrders() {
        req.getRequest(`${config.api}/user/service2/orders`)
            .then(r => {
                let list = r ? r : [];
                list = list ? list : [];
                this.setState({servicesOrders: list});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    getOrders() {
        req.getRequest(`${config.api}/user/orders`)
            .then(r => {
                this.setState({orders: r});
            })
            .catch(err => {
                config.handleError(err);
            });
    }


    statusColor(status = "") {
        let color = "#FF3D00";
        if (status.includes("سفارش موفق") || status.includes("واریز شده")) {
            color = "#139f01";
        } else if (status.includes("لغو") || status.includes("واریز نشده") || status.includes("ناموفق")) {
            color = "#c00e0e"
        } else if (status.includes("اولیه") || status.includes("نامشخص")) {
            color = "#959595"
        }
        return color;
    }

    handleOpen(index, open = false, type = "orders") {
        let {orders, servicesOrders} = this.state;
        if (type === "orders") {
            orders[index].open = open;
            this.setState({orders});
        } else {
            servicesOrders[index].open = open;
            this.setState({servicesOrders});
        }
    }

    render() {
        let {orders, servicesOrders} = this.state;
        return (
            <div className="orders">
                <ModalLoading loading={!orders}/>
                {
                    orders ?
                        <>
                            <h2>سفارشات تسهیلات</h2>
                            {orders.length > 0 ?
                                <div className="list">
                                    {orders.map((o, i) =>
                                        <article key={"order" + i}>
                                            <Collapsible
                                                onTriggerOpening={() => this.handleOpen(i, true, "orders")}
                                                onTriggerClosing={() => this.handleOpen(i, false, "orders")}
                                                trigger={
                                                    <div className="collapse-header">
                                                        <div className="row">
                                                            <div className="col-auto">
                                                                <div className="status-circle"
                                                                     style={{backgroundColor: this.statusColor(o.status)}}>
                                                                </div>
                                                            </div>
                                                            <div className="col">
                                                                <div className="created-at"
                                                                     style={{color: this.statusColor(o.status)}}>{o.code !== "" ? o.code : o.createdAt.split(" ")[0]}</div>
                                                            </div>
                                                            <div className="col-auto">
                                                                <Icon i={o.open ? "chevron-up" : "chevron-down"}
                                                                      className="arrow-icon"/>
                                                            </div>
                                                        </div>

                                                    </div>
                                                }
                                                transitionTime={50}>
                                                <div className="body">
                                                    {o.form.length > 0 ?
                                                        <div className="order-form">
                                                            <div className="title">فرم</div>
                                                            {o.form.map((f, fi) =>
                                                                <p key={"form" + fi}>
                                                                    <span>{f.title}:</span><span>{f.value}</span>
                                                                </p>
                                                            )}
                                                        </div>
                                                        : null}
                                                    {o.facilities.length > 0 ?
                                                        <div className="order-facilities">
                                                            <div className="title">طرح ها</div>
                                                            {o.facilities.map((f, fi) =>
                                                                <>
                                                                    <p key={"facilities" + fi}>
                                                                        <span>{f.title}:</span><span>{config.priceFormatter(f.registerPrice)}&nbsp;تومان</span>
                                                                    </p>
                                                                    {f.link ?
                                                                        f.link !== "" ?
                                                                            <div className="register-link">
                                                                                <a href={f.link} target="_blank">لینک
                                                                                    ثبت
                                                                                    نام
                                                                                    طرح {f.title}</a>
                                                                            </div>
                                                                            : null : null
                                                                    }
                                                                </>
                                                            )
                                                            }
                                                        </div>
                                                        : null}
                                                    {o.services.length > 0 ?
                                                        <div className="order-services">
                                                            <div className="title">خدمات</div>
                                                            {o.services.map((f, fi) =>
                                                                <p key={"services" + fi}>
                                                                    <span>{f.title}:</span><span>{config.priceFormatter(f.price)}&nbsp;تومان</span>
                                                                </p>
                                                            )
                                                            }
                                                        </div>
                                                        : null}

                                                    <div className="order-status">
                                                        <div className="title">وضعیت سفارش</div>
                                                        <p className="status"><span>وضعیت:</span><span
                                                            style={{color: this.statusColor(o.status)}}>{o.status}</span>
                                                        </p>
                                                        <p><span>توضیح مدیریت:</span></p>
                                                        <pre className="admin-description">{o.adminDescription}</pre>
                                                    </div>


                                                    <p className="created-at">
                                                        <span>ثبت شده در:</span><span>{o.createdAt}</span>
                                                    </p>

                                                </div>
                                            </Collapsible>
                                        </article>
                                    )}
                                </div>
                                : <div className="no-order-item">تاکنون سفارشی ثبت نکرده اید!</div>
                            }
                        </>
                        : null
                }

                {
                    servicesOrders?.length > 0 ?
                        <>
                            <br/>
                            <h2>سفارشات خدمات</h2>
                            <div className="list">
                                {servicesOrders?.map((o, i) =>
                                    <article key={"sorder" + i}>
                                        <Collapsible
                                            onTriggerOpening={() => this.handleOpen(i, true, "servicesOrders")}
                                            onTriggerClosing={() => this.handleOpen(i, false, "servicesOrders")}
                                            trigger={
                                                <div className="collapse-header">
                                                    <div className="row">
                                                        <div className="col-auto">
                                                            <div className="status-circle"
                                                                 style={{backgroundColor: this.statusColor(o.status)}}>
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <div className="created-at"
                                                                 style={{color: this.statusColor(o.status)}}>{o.code !== "" ? o.code : o.createdAt.split(" ")[0]}</div>
                                                        </div>
                                                        <div className="col-auto">
                                                            <Icon i={o.open ? "chevron-up" : "chevron-down"}
                                                                  className="arrow-icon"/>
                                                        </div>
                                                    </div>

                                                </div>
                                            }
                                            transitionTime={50}>
                                            <div className="body">
                                                {o.services.length > 0 ?
                                                    <div className="order-services">
                                                        <div className="title">خدمات</div>
                                                        {o.services.map((f, fi) =>
                                                            <>
                                                                <p key={"services" + fi}>
                                                                    <span>{f.title}:</span><span>{config.priceFormatter(f.price)}&nbsp;تومان</span>
                                                                </p>
                                                            </>
                                                        )
                                                        }
                                                    </div>
                                                    : null}

                                                <div className="order-status">
                                                    <div className="title">وضعیت سفارش</div>
                                                    <p className="status"><span>وضعیت:</span><span
                                                        style={{color: this.statusColor(o.status)}}>{o.status}</span>
                                                    </p>
                                                </div>


                                                <p className="created-at">
                                                    <span>ثبت شده در:</span><span>{o.createdAt}</span>
                                                </p>

                                                <div className="signature-services-orders">
                                                    <img src={o.signature} alt=""/>
                                                </div>
                                            </div>
                                        </Collapsible>
                                    </article>
                                )}
                            </div>

                        </> : null
                }

            </div>
        );
    }
}

export default gpn(Orders);